import styled from "styled-components";
import { IMAGES } from "../../../constants/images";

export default function ExpendedButton({ onClick, isActive = false, isExpanded, handleExpanded }) {
  return (
    <ExpendedButtonContainer isActive={isActive}>
      <LeftButton onClick={onClick} isActive={isActive}>
        <img src={IMAGES.HOME} alt="Home" />
        <span>Draw asset contour</span>
      </LeftButton>
      <RightButton onClick={handleExpanded} isActive={isActive}>
        <img src={isExpanded ? IMAGES.ARROW_DOWN : IMAGES.ARROW_UP} alt="Arrow up/down" />
      </RightButton>
    </ExpendedButtonContainer>
  );
}

const ExpendedButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;

  background-color: ${({ isActive }) => (isActive ? "#0f77ffff" : "white")};
  color: ${({ isActive }) => (isActive ? "white" : "black")};
  font-weight: ${({ isActive }) => (isActive ? "bold" : "normal")};
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
`;

const RightButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;
  transition: background-color 0.3s;

  img {
    width: 10px;
  }

  &:hover {
    background-color: ${({ isActive }) => (isActive ? "#0f77ffff" : "#ececec")};
  }
`;

const LeftButton = styled.button`
  all: unset;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 10px;
  transition: background-color 0.3s;

  img {
    height: 16px;
  }

  &:hover {
    background-color: ${({ isActive }) => (isActive ? "#0f77ffff" : "#ececec")};
  }
`;
